<template>
  <div class="container-fluid d-flex align-items-center justify-content-center col-lg-4" style="min-height: 100vh">
    <div class="main-section__wrapper bg-white ">
      <h2 class="title2 text-center">Thank you</h2>
      <p class="body text-center mt-4">
        A request has been sent. Please check your email to see the status of
        your order
      </p>
      <div class="text-center mt-15">
        <router-link :to="{name:'giftstorev2'}">
          <button
                  class="btn btn-primary mt-2 btn-lg br-5">
            Continue Ordering
          </button>
        </router-link>
      </div>
      <GiftcardFooter class="mt-15"/>
    </div>
  </div>

</template>

<script lang="ts">

import GiftcardFooter from "./GiftCardFooter.vue";
import { mapMutations } from "vuex";

export default {
  components: { GiftcardFooter },
  mounted() {
    this.setStoreLoaded();
  },
  methods: {
    ...mapMutations(["setStoreLoaded"]),
  }
};
</script>

<style scoped>
.footer-wrapper {
  position: absolute;
  left: 50%;
  bottom: 0;
  transform: translateX(-50%);
  height: 6rem;
  width: 100%;
}
.main-section__wrapper {
  box-sizing: border-box;

}

.mt-15 {
  margin-top: 15% !important;
}

@media only screen and (max-width: 900px) {
  .main-section__wrapper {
    padding: 1rem 1rem;
  }
  .btn-block {
    width: 100%;
  }
}
</style>
